import Image from "react-bootstrap/Image";
import backendUrl from "../../../../utilities/backendUrl";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { useMutation } from "@tanstack/react-query";
import { getService } from "../../../../function/helper";
import Swal from "sweetalert2";
import styles from "./NavPillTrackingCompany.module.css";
import NavPillTrackingCompanyTable from "./NavPillTrackingCompanyTable";

const NavPillTrackingCompany = () => {
  const companies = [
    { id: 1, label: "پست ملی", name: "post", img: "/images/logopost.png" },
    {
      id: 2,
      label: "ماهکس اکسپرس",
      name: "mahex",
      img: "/images/mahex-logo.png",
    },
    {
      id: 3,
      label: "کالارسانان چاپار",
      name: "chapar",
      img: "/images/chaparLOGO.png",
    },
    {
      id: 5,
      label: "آوا باکس",
      name: "avabox",
      img: "/images/avabox-logo.png",
    },
    { id: 6, label: "تیپاکس", name: "tipax", img: "/images/tipax-logo.png" },
    {
      id: 9,
      label: "دکاپست",
      name: "dekapost",
      img: "/images/dekapost-logo.png",
    },
  ];

  const [selectedCompany, setSelectedCompany] = useState({});
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const {
    isPending,
    data: trackingData,
    mutate,
    reset,
  } = useMutation({
    mutationKey: ["navpills-tracking-company"],
    mutationFn: barcode =>
      getService(
        `/company/track/${selectedCompany.name}?barcode=${barcode}&old=1`
      ).then(res => {
        if (res.status === 200) {
          return res.data.result;
        }

        Swal.fire({
          icon: "error",
          title: res.message,
          confirmButtonColor: "red",
          confirmButtonText: "متوجه شدم",
        });

        return null;
      }),
  });

  return (
    <section className="pt-3">
      <h4>رهگیری مرسوله با بارکد پستی</h4>

      <ul className="d-flex flex-wrap justify-content-center column-gap-4 row-gap-3 mt-5">
        {companies.map(item => (
          <li
            key={item.id}
            className={[
              "list-inline",
              "text-center",
              styles.item,
              selectedCompany.id === item.id ? styles.itemActive : "",
            ].join(" ")}
          >
            <Image
              src={backendUrl + item.img}
              onClick={() =>
                setSelectedCompany(cur => {
                  reset();
                  return cur.id === item.id ? {} : item;
                })
              }
            />
            <p className="fs-samll text-center p-0 m-0">{item.label}</p>
          </li>
        ))}
      </ul>

      {selectedCompany.id === undefined && (
        <p className="text-center mt-4">
          لطفا سرویس دهنده مورد نظر را انتخاب کنید
        </p>
      )}

      {selectedCompany.id !== undefined && (
        <form onSubmit={handleSubmit(value => mutate(value.barcode))}>
          <div className="d-flex flex-wrap px-2 px-sm-3 px-lg-4 px-xxl-7 my-5">
            <Form.Control
              size="md"
              type="text"
              className="w-100 w-md-75 rounded-0"
              placeholder="بارکد پستی را وارد کنید"
              {...register("barcode", {
                required: { value: true, message: "بارکد پستی الزامی" },
              })}
            />
            {isPending && (
              <LoadingButton
                className="btn-success-style text-white rounded-0 w-100 w-md-25"
                center
                title="در حال رهگیری"
              />
            )}

            {!isPending && (
              <Button
                type="submit"
                className="btn-success-style rounded-0 w-100 w-md-25"
              >
                رهگیری
              </Button>
            )}
            {errors.barcode && (
              <p className="mb-0 text-danger">{errors.barcode.message}</p>
            )}
          </div>
        </form>
      )}

      {!!trackingData && (
        <NavPillTrackingCompanyTable trackingData={trackingData} />
      )}
    </section>
  );
};

export default NavPillTrackingCompany;
